import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=335d34c4&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=335d34c4&prod&scoped=true&lang=css&external"
import style1 from "./Client.vue?vue&type=style&index=1&id=335d34c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d34c4",
  null
  
)

export default component.exports